export const GET_USER = "/users";
export const PUT_USER = "/users/edit";
export const PUT_CHANGE_PASSWORD = "/users/password/edit";
export const DELETE_ACCOUNT = "/users/delete";
export const POST_RESET_PASSWORD = "/users/password/reset";
export const POST_RESEND_CONFIRMATION = "/users/resend_confirmation";
export const GET_CONFIRMATIONS = "/users/confirmation";
export const POST_REFRESH_TOKEN = "/users/refresh_token";
